import { HuiLogout } from '@mit/hui-core'
import { useNavigate } from 'react-router-dom'

import React, { useEffect } from 'react'

interface LogoutProps {}

export const Logout: React.FC<LogoutProps> = ({}) => {
  const navigate = useNavigate()
  const hasReauthenticated = localStorage.getItem('RefreshAuthentication') !== null

  useEffect(() => {
    if (hasReauthenticated === true) {
      localStorage.removeItem('RefreshAuthentication')
      navigate('/') // for someone unknown reason this needs to be wrapped in a use effect
    }
  }, [hasReauthenticated])

  return <HuiLogout />
}
